import RealtimeMonitoringTab from '../project-details/realtime-monitoring/RealtimeMonitoringTab';

const RealtimeMonitoringPage = () => {
  return (
    <div style={{ background: '#f8f9fa', minHeight: '100vh' }}>
      <RealtimeMonitoringTab />
    </div>
  );
};

export default RealtimeMonitoringPage;
